import { useParams, useLocation, useHistory } from "react-router-dom";
import { useState } from "react";
import "./LanguageSwitcher.css";
import React from "react";
import BrandLoader from '../Assetes/Images/kfc_loader.gif';
import BrandLoaderlogo from '../Assetes/Images/KFC-Logo-Red.png';
import CircularProgress from '@mui/material/CircularProgress';
import EnFlag from '../Assetes/Images/flags/en.svg';
import FrFlag from '../Assetes/Images/flags/fr.svg';
import DzFlag from '../Assetes/Images/flags/ar.svg';

const LanguageSwitcher = () => {
  const { lang } = useParams<{ lang: string }>();
  const location = useLocation();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const languages = [
    { code: "en", name: "English", flag: EnFlag },
    // { code: "fr", name: "Français", flag: FrFlag },
    { code: "ar", name: "العربية", flag: DzFlag },
  ];

  const currentLanguage =
    languages.find((l) => l.code === lang) || languages[0];

  const changeLang = (newLang: string) => {
    if (!lang) return;
    setIsLoading(true);
    setIsOpen(false);
    const newPath = location.pathname.replace(`/${lang}`, `/${newLang}`);
    history.push(newPath);
    window.location.reload();
  };

  return (
    <React.Fragment>
      <div className="language-switcher">
        <button
          className="language-switcher__toggle"
          onClick={() => setIsOpen(!isOpen)}
        >
          {/* <img
            src={currentLanguage.flag}
            alt={currentLanguage.name}
            className="language-switcher__flag"
          /> */}
          <span>{currentLanguage.name}</span>
          <svg
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1.5L6 6.5L11 1.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {isOpen && (
          <div className="language-switcher__dropdown">
            {languages.map((language) => (
              <button
                key={language.code}
                className={`language-switcher__item ${
                  lang === language.code ? "active" : ""
                  }`}
                onClick={() => changeLang(language.code)}
              >
                <img
                  src={language.flag}
                  alt={language.name}
                  className="language-switcher__flag"
                />
                {language.name}
              </button>
            ))}
          </div>
        )}
      </div>

      {isLoading && (
        <div className="language-loader-overlay">
          {/* <CircularProgress
            size="5rem"
            className="language-loader-spinner"
          /> */}
          <img className="language-loader-spinner-kfc" src={BrandLoaderlogo} alt="brand-loader" />
        </div>
      )}
    </React.Fragment>
  );
};

export default LanguageSwitcher;


